// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/components/tenants/ticket-types/styles.scss
// module id = 140
// module chunks = 65